import Detector from './base';

const SYNONYMS = [
  'trade',
  'traded',
  'trader',
  'traders',
  'trading',
  'swap',
];
const NAMESPACE = 'trade';

export default new Detector(SYNONYMS, NAMESPACE);
